/**
 * @author zy
 * 2020-04-30
 * 课堂助手-查看问卷接口
 *
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './columns'
import SurveyResultCharts from './surveyResultCharts'
import {modelUtils} from '@/utils'
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {WizModalUserIdentityShow} from '@/containers/common';
import logger from "less/lib/less/logger";
import ClassStudentAideInfo from './../classStudentAide/classStudentAideInfo'

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizSpin} = component_tool;
let {Session} = utils_tool;

class ClassStudentSurveyList extends WizContainer {

  componentName = 'ClassStudentSurveyList';

  constructor(props) {
    super(props);
    const { history } = props;
    this.state = {
      selectedClassResultRows: [],//选择的学员
      showUserPersonInfoVisible: false,
      classStudentSurveyInfo:{}
    };

    if (history.location &&  history.location.pathname === "/face/classList/classAideDetail/classStudentSurveyList") {
      if (history.location.record) {
        this.classStudentSurveyRecord = history.location.record
        Session.set('classStudentSurveyRecord', this.classStudentSurveyRecord);
      } else {
        this.classStudentSurveyRecord = Session.get('classStudentSurveyRecord') || {}
      }
    }

  }

  // _componentDidMount() {
  //   this.doActions([
  //     {
  //       path: 'survey/getSurveyInfo',
  //       payload: {
  //         key: 'getSurveyInfo',
  //         apiParams: { id: this.classStudentSurveyRecord.id }
  //       }
  //     }
  //   ])
  // }

  propsAndStateOnChange = {
  };



  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateName',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否答卷',
        field: 'isJoinSurveyName',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '答卷时间',
        field: 'submissionDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '满意度评分',
        field: 'scoreAvg',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data'];
      let dataNew = data;
      if(data && data.length>0){
        dataNew = [];
        let questionIds = [];
        data.forEach(element=>{
          if(element.questions && element.questions.length) {
            element.questions.forEach(e => {
              if(questionIds.indexOf(e.title) <= -1){
                columnDefs.push({
                  headerName: e['title'],
                  field: e['title'],
                  width: 20,
                  cellStyle: {
                    textAlign: 'center',
                  },
                  style: {
                    alignment: { vertical: 'bottom', horizontal: 'left' },
                  }
                })
                questionIds.push(e.title);
              }
             // element[e.title]=e.answer 
              let answerOptions = []
              let title = new Set();
              if (e['answerOptions'] && e['answerOptions'].length) {
                answerOptions = e['answerOptions']
                answerOptions.forEach(a => {
                  if (a['content']) {
                    title.add(a['content'])
                  }
                })
              }else {
                if (e['answer']) {
                  title.add(e['answer'])
                }
              }
              if (e['otherAnswer'] && e['otherAnswer'].length) {
                title.add(e['otherAnswer'])
              }
              element[e['title']] = Array.from(title).toString();
            })
          }
          element.leaveStateStr = element.leaveState ===0 ? '否' : "是"
          dataNew.push(element);
        })
      }
      WizBrowserExport({
        title: '班级问卷信息',
        sheetName: '班级问卷信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataNew,
        filename: '班级问卷信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  //导出学员信息+答卷详情
  _exportClassStudentSurveyDetail(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '问卷名称',
        field: 'surveyName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '班级名称',
        field: 'classInfoName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '讲师',
        field: 'lectureName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '用户属性',
        field: 'userTypeName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '账号状态',
        field: 'stateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '答卷时间',
        field: 'submissionDate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },

    ]
    if (o['success']) {
      let data = o['data'];
      let titleMaplist = data.titleMaplist;
      let data_ = data.data;
      let totleCount = data.totleCount;
      let openCount = data.openCount;
      let submitCount = data.submitCount;

      if (titleMaplist && titleMaplist instanceof Array) {
        titleMaplist.forEach(element => {
          element.width = 10;
          element.cellStyle = {
            textAlign: 'center',
          }
          element.style = {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          }
          columnDefs.push({ ...element})
        });
      }
      WizBrowserExport({
        title: '班级总人数: '+ totleCount + '\n' + '已打开人数: '+openCount + '\n' + '已提交人数: ' + submitCount ,
        sheetName: '班级问卷信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data_,
        filename: '班级问卷信息.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  /**
   * 获取查看学员班级任职信息
   * @param classResultRecord
   * @private
   */
  _showUserPersonModal = (classStudentSurveyInfo) => {
    this.setState({
      classStudentSurveyInfo,
      showUserPersonInfoVisible: true,
    })

  };

  _render() {
    const {classStudentSurveyLoading} = this.props;
    const {showUserPersonInfoVisible, classStudentSurveyInfo} = this.state;
    let classInfoId = this.classStudentSurveyRecord ? this.classStudentSurveyRecord.classId : null;
    let surveyId = this.classStudentSurveyRecord ? this.classStudentSurveyRecord.id : null;
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassResultRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      classInfoId,
      surveyInfo:this.classStudentSurveyRecord
    });
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      classInfoId,
      surveyId,
      apiDataFormat: {
        exportClassStudentSurveyByCondition: this._handleFile,
        exportClassStudentSurveyDetailByCondition:this._exportClassStudentSurveyDetail,
      },
    });
    return (
      <>
        <WizSpin tip={"加载中"} spinning={classStudentSurveyLoading }>
          <ClassStudentAideInfo {...this.classStudentSurveyRecord} />
          <WizCard title={'环节记录'}>
            <WizReduxTemplate  {..._reduxTemplateCofig} />
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classStudentSurvey,survey} = state;
  const load = modelUtils.getLoadingState(state, ['classStudentSurvey']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentSurveyList);
